const sectionFeaturedOfferCss = `
[data-type='section-featured-offer'] .container {
  padding-inline: 0 !important;
}

[data-type='section-featured-offer'] .featured-offer-wrapper {
  padding-block: 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

[data-type='section-featured-offer'] .featured-offer-title:not(:empty) {
  margin-bottom: 24px;
}

[data-type='section-featured-offer'] .featured-offer-title h1,
[data-type='section-featured-offer'] .featured-offer-title h2,
[data-type='section-featured-offer'] .featured-offer-title h3,
[data-type='section-featured-offer'] .featured-offer-card-content h1,
[data-type='section-featured-offer'] .featured-offer-card-content h2,
[data-type='section-featured-offer'] .featured-offer-card-content h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 12px 0 !important;
}

[data-type='section-featured-offer'] .featured-offer-title h1:last-child,
[data-type='section-featured-offer'] .featured-offer-title h2:last-child,
[data-type='section-featured-offer'] .featured-offer-title h3:last-child,
[data-type='section-featured-offer'] .featured-offer-card-content h1:last-child,
[data-type='section-featured-offer'] .featured-offer-card-content h2:last-child,
[data-type='section-featured-offer'] .featured-offer-card-content h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-featured-offer'] .featured-offer-title p,
[data-type='section-featured-offer'] .featured-offer-card-content p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-featured-offer'] .featured-offer-title p:last-child,
[data-type='section-featured-offer'] .featured-offer-card-content p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-featured-offer'] .featured-offer-card-wrapper {
  padding: 50px 30px;
  background-color: #fefdea;
}

[data-type='section-featured-offer'] .featured-offer-card-wrapper .featured-offer-card {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px dashed #707071;
}

[data-type='section-featured-offer'] .featured-offer-card-wrapper .featured-offer-card[data-image-position='left'] {
  flex-direction: row;
}

[data-type='section-featured-offer'] .featured-offer-card-wrapper .featured-offer-card[data-image-position='right'] {
  flex-direction: row-reverse;
}

[data-type='section-featured-offer'] .featured-offer-card-wrapper .featured-offer-card .featured-offer-card-image {
  width: 400px;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: fit-content;
}

[data-type='section-featured-offer'] .featured-offer-card-wrapper .featured-offer-card .featured-offer-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-featured-offer'] .featured-offer-card-wrapper .featured-offer-card .featured-offer-card-content {
  flex: 1;
  padding: 20px;
}

[data-type='section-featured-offer'] .featured-offer-card-wrapper .featured-offer-card .featured-offer-card-content .featured-offer-card-content-header {
  margin-bottom: 8px;
}

[data-type='section-featured-offer'] .featured-offer-card-wrapper .featured-offer-card .featured-offer-card-content .featured-offer-card-content-button-wrapper {
  display: flex;
  justify-content: left;
  margin: 0 0 24px 0 !important;
}

[data-type='section-featured-offer']
  .featured-offer-card-wrapper
  .featured-offer-card
  .featured-offer-card-content
  .featured-offer-card-content-button-wrapper[data-button-position='center'] {
  justify-content: center;
}

[data-type='section-featured-offer']
  .featured-offer-card-wrapper
  .featured-offer-card
  .featured-offer-card-content
  .featured-offer-card-content-button-wrapper[data-button-position='left'] {
  justify-content: flex-start;
}

[data-type='section-featured-offer']
  .featured-offer-card-wrapper
  .featured-offer-card
  .featured-offer-card-content
  .featured-offer-card-content-button-wrapper[data-button-position='right'] {
  justify-content: flex-end;
}

[data-type='section-featured-offer'] .featured-offer-card-wrapper .featured-offer-card .featured-offer-card-content .featured-offer-card-content-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #90cf5b;
  border-radius: 8px;
  padding: 10px 20px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  text-decoration: none;
  width: fit-content;
  max-width: fit-content;
  cursor: pointer;
  min-width: 300px;
  text-transform: uppercase;
  text-align: center;
  transition-property: box-shadow;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  animation: pulse-scale 1.5s ease-in-out infinite;
}

[data-type='section-featured-offer']
  .featured-offer-card-wrapper
  .featured-offer-card
  .featured-offer-card-content
  .featured-offer-card-content-button:hover {
  opacity: 0.8;
}

@keyframes pulse-scale {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.9;
  }
}

@container (max-width: 768px) {
  [data-type='section-featured-offer'] .featured-offer-wrapper {
    padding-block: 16px;
    gap: 8px;
  }

  [data-type='section-featured-offer'] .featured-offer-title,
  [data-type='section-featured-offer'] .featured-offer-card-content {
    padding-inline: 8px;
  }

  [data-type='section-featured-offer'] .featured-offer-title h1,
  [data-type='section-featured-offer'] .featured-offer-title h2,
  [data-type='section-featured-offer'] .featured-offer-title h3,
  [data-type='section-featured-offer'] .featured-offer-card-content h1,
  [data-type='section-featured-offer'] .featured-offer-card-content h2,
  [data-type='section-featured-offer'] .featured-offer-card-content h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-featured-offer'] .featured-offer-title p,
  [data-type='section-featured-offer'] .featured-offer-card-content p {
    font-size: 14px;
  }

  [data-type='section-featured-offer'] .featured-offer-card-wrapper {
    padding: 8px;
  }

  [data-type='section-featured-offer'] .featured-offer-card-wrapper .featured-offer-card[data-image-position='left'],
  [data-type='section-featured-offer'] .featured-offer-card-wrapper .featured-offer-card[data-image-position='right'] {
    flex-direction: column;
  }

  [data-type='section-featured-offer'] .featured-offer-card-wrapper .featured-offer-card .featured-offer-card-image {
    width: 100%;
    height: 100%;
  }

  [data-type='section-featured-offer'] .featured-offer-card-wrapper .featured-offer-card .featured-offer-card-content {
    padding: 16px;
  }

  [data-type='section-featured-offer'] .featured-offer-card-wrapper .featured-offer-card .featured-offer-card-content .featured-offer-card-content-button {
    min-width: 200px;
  }
}
`;
export default sectionFeaturedOfferCss;
